import { useLogin } from 'react-admin';
import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import {Resources} from '@/src/shared/constants/resources';

function useAuthenticate() {
  const loginUser = useLogin();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function login({ email, password }: { [key: string]: string }) {
    setIsLoading(true);
    setIsSuccess(false);
    return loginUser({ email, password }, `/${Resources.ClubProfile}`)
      .then(() => setIsSuccess(true))
      .catch((error: Error) => {
        console.log('loginError ', error);
        enqueueSnackbar(error.message, {
          variant: 'error',
        });
      })
      .finally(() => setIsLoading(false));
  }

  return { login, isLoading, isSuccess };
}

export default useAuthenticate;
